import { useAssetsUpload } from '@mi-front/api-v2';
import { useToast } from '@app/core/notifications';
import { FileInput, FileInputProps } from '@mi-front/ui';
import { useIntl } from 'react-intl';

export interface Props {
  inputProps?: Partial<FileInputProps>;
  onUploaded: (url: string) => void;
}

export function UploadAsset(p: Props) {
  const upload = useAssetsUpload();
  const { $t } = useIntl();
  const { notifyError } = useToast();

  function doUpload(file: File) {
    upload.mutate(
      {
        data: {
          file,
        },
      },
      {
        onSuccess: (data) => {
          p.onUploaded(data.url);
        },
        onError: (error) => {
          notifyError(
            $t({
              id: 'assets.upload.error',
              defaultMessage: 'Ocurrió un error al cargar el archivo, intente nuevamente',
            }),
          );

          console.error(error);
        },
      },
    );
  }

  return (
    <div>
      <FileInput
        label={$t({
          id: 'assets.upload.label',
          defaultMessage: 'Subir recurso',
        })}
        {...p.inputProps}
        loading={upload.isPending}
        onChange={function (files: File[]): void {
          if (files[0]) {
            doUpload(files[0]);
          }
        }}
      />
    </div>
  );
}
